import React from "react";
import ColorOption from "./ColorOption";
import {useSelector} from "react-redux";

const ExteriorTonePreview = ({
                               primaryColorItem,
                               secondaryColorItem,
                               stepObject,
                               navigationDataObject,
                               slideToSubHandler
                             }) => {
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);

  const hasSecondarySelected = !!sendData["EXT_SPECIAL"];

  const title = hasSecondarySelected ? "DUAL TONE" : "SINGLE TONE";

  return (
    <div className={"tone-preview"}>
      {/* Primary Color with Header */}
      <ColorOption
        code={"EXT_MAIN"}
        colorItemObject={primaryColorItem}
        navigationDataObject={navigationDataObject}
        stepObject={stepObject}
        slideToSubHandler={slideToSubHandler}
        targetDepth="2"
        showHeader={true}
        headerTitle={title}
        visible={true}
        disableOptionClick={true}
      />

      {/* Secondary Color */}
      <ColorOption
        code={"EXT_SPECIAL"}
        colorItemObject={secondaryColorItem}
        navigationDataObject={navigationDataObject}
        stepObject={stepObject}
        slideToSubHandler={slideToSubHandler}
        targetDepth="2"
        visible={hasSecondarySelected}
        disableOptionClick={true}
      />
    </div>
  );
}

export default ExteriorTonePreview;
